import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '#contexts/auth';
import { MainLayout } from '#components';
import { AccountProvider } from '#contexts/account';

export const PrivateRoute = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/home" />;
  }

  return (
    <AccountProvider>
      <MainLayout>
        <Outlet />
      </MainLayout>
    </AccountProvider>
  );
};
